// src/constants/nahwuDictionary.js
// Kamus transliterasi + parser + kamus arti kata

// ════════════════════════════════════════════════════════════
// KAMUS TRANSLITERASI
// Untuk kata/kalimat PELENGKAP saja.
// Bagian utama I'rab (seperti فعل ماضٍ, فاعل, حرف جر)
// tetap dalam Bahasa Arab (khas kitab pesantren).
// ════════════════════════════════════════════════════════════

export const transliterationMap = {
  // ── Kata "Mabni" ──
  'مبني على السكون':         "Mabni 'ala as-Sukun",
  'مبني على الفتح':          "Mabni 'ala al-Fathah",
  'مبني على الضم':           "Mabni 'ala adh-Dhammah",
  'مبني على الكسر':          "Mabni 'ala al-Kasrah",

  // ── Alasan Mabni ──
  'لاتصاله بتاء الفاعل':     "li-Ittishalihi bi Ta' al-Fa'il",
  'لاتصاله بياء المخاطبة':   "li-Ittishalihi bi Ya' al-Mukhathabah",
  'لاتصاله بنون التوكيد':    "li-Ittishalihi bi Nun at-Taukid",
  'لاتصاله بألف الاثنين':    "li-Ittishalihi bi Alif al-Itsnain",
  'لاتصاله بواو الجماعة':    "li-Ittishalihi bi Waw al-Jama'ah",
  'لاتصاله بنون النسوة':     "li-Ittishalihi bi Nun an-Niswah",

  // ── Kedudukan I'rab ──
  'مرفوع':                   "Marfu'",
  'منصوب':                   "Mansub",
  'مجرور':                   "Majrur",
  'مجزوم':                   "Majzum",

  // ── Tanda I'rab ──
  'وعلامة رفعه الضمة':       "wa 'Alamat Raf'ihi adh-Dhammah",
  'وعلامة رفعه الواو':       "wa 'Alamat Raf'ihi al-Waw",
  'وعلامة رفعه الألف':       "wa 'Alamat Raf'ihi al-Alif",
  'وعلامة رفعه ثبوت النون':  "wa 'Alamat Raf'ihi Tsubuti an-Nun",
  'وعلامة نصبه الفتحة':      "wa 'Alamat Nashbihi al-Fathah",
  'وعلامة نصبه الياء':       "wa 'Alamat Nashbihi al-Ya'",
  'وعلامة نصبه الألف':       "wa 'Alamat Nashbihi al-Alif",
  'وعلامة نصبه حذف النون':   "wa 'Alamat Nashbihi Hadzfi an-Nun",
  'وعلامة جره الكسرة':       "wa 'Alamat Jarrihi al-Kasrah",
  'وعلامة جره الياء':        "wa 'Alamat Jarrihi al-Ya'",
  'وعلامة جزمه السكون':      "wa 'Alamat Jazmihi as-Sukun",
  'وعلامة جزمه حذف حرف العلة': "wa 'Alamat Jazmihi Hadzfi Harfi al-'Illah",

  // ── Penampakan Tanda ──
  'الظاهرة على آخره':        "adz-Dhahirah 'ala Akhirihi",
  'الظاهرة':                 "adz-Dhahirah",
  'المقدرة على الألف':       "al-Muqaddarah 'ala al-Alif",
  'المقدرة على الياء':       "al-Muqaddarah 'ala al-Ya'",
  'المقدرة':                 "al-Muqaddarah",
  'المحذوفة':                "al-Mahdzhufah",

  // ── Keterangan Tambahan ──
  'وهو':                     "wa Huwa",
  'وهي':                     "wa Hiya",
  'والهاء':                  "wa al-Ha'",
  'والياء':                  "wa al-Ya'",
  'لأنه':                    "li-Annahu",
  'لأنها':                   "li-Annaha",

  // ── Kata Penghubung / Hubungan ──
  'متعلق بـ':                "Muta'alliq bi",
  'متعلق بمحذوف':            "Muta'alliq bi Mahdzhuf",
  'متعلق بالفعل':            "Muta'alliq bi al-Fi'il",
  'متعلق بالخبر':            "Muta'alliq bi al-Khabar",
  'متعلق بالمبتدأ':          "Muta'alliq bi al-Mubtada'",

  'صفة لـ':                  "Shifatun li",
  'صفة ل':                   "Shifatun li",
  'صفة':                     "Shifatun",
  'بدل':                     "Badalun",
  'عطف بيان':                "'Athf Bayan",
  'توكيد':                   "Taukid",
  'عطف':                     "'Athf",

  // ── Macam-macam Maf'ul ──
  'مفعول مطلق':              "Maf'ul Muthlaq",
  'مفعول لأجله':             "Maf'ul li-Ajlihi",
  'مفعول فيه':               "Maf'ul Fih",
  'مفعول معه':               "Maf'ul Ma'ahu",
  'مفعول به':                "Maf'ul Bih",
  'حال':                     "Halun",
  'تمييز':                   "Tamyiz",

  // ── Fi'il Naqish ──
  'اسمه':                    "Ismuhu (Isim-nya)",
  'اسمها':                   "Ismuha (Isim-nya)",
  'خبره':                    "Khabaruhu (Khabar-nya)",
  'خبرها':                   "Khabaruha (Khabar-nya)",
  'ضمير مستتر':              "Dhamir Mustatir",
  'ضمير بارز':               "Dhamir Bariz",

  // ── Penunjuk Mahall ──
  'في محل نصب':              "fi Mahalli Nashb",
  'في محل رفع':              "fi Mahalli Raf'",
  'في محل جر':               "fi Mahalli Jar",
  'في محل جزم':              "fi Mahalli Jazm",
  'محل':                     "Mahall",

  // ── Jenis Keterangan ──
  'لفظي':                    "Lafdhi",
  'معنوي':                   "Ma'nawi",
  'جملة':                    "Jumlah",
  'شبه جملة':                "Syibh Jumlah",
  'والمفعول به':             "wa al-Maf'ul Bih",
  'والفاعل':                 "wa al-Fa'il",

  // ── Bentuk Isim dari Mabni ──
  'مبني':                    "Mabniyyun",
  'مبنية':                   "Mabniyyatun",

  // ── Jamak (Plural) ──
  'جمع مؤنث سالم':           "Jam' Mu'annath Salim",
  'جمع مذكر سالم':           "Jam' Mudhakkar Salim",
  'مفرد':                    "Mufrad",
  'مثنى':                    "Mutsanna",
};

// ════════════════════════════════════════════════════════════
// FUNGSI: Transliterasi Selektif
// ════════════════════════════════════════════════════════════

export function transliterateDetail(text) {
  if (!text) return '';
  if (typeof text !== 'string') return String(text);

  let result = text;

  const sortedKeys = Object.keys(transliterationMap)
    .sort((a, b) => b.length - a.length);

  for (const key of sortedKeys) {
    if (result.includes(key)) {
      const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      result = result.replace(
        new RegExp(escapedKey, 'g'),
        transliterationMap[key]
      );
    }
  }

  return result;
}

// Alias untuk kompatibilitas
export const transliterateIrab = transliterateDetail;

// ════════════════════════════════════════════════════════════
// PARSER: Pecah I'rab menjadi Main + Detail + Connector
// ════════════════════════════════════════════════════════════

export function parseIrab(text) {
  const defaultResult = { main: '', detail: '', connector: '' };

  if (!text || typeof text !== 'string') return defaultResult;
  const trimmedText = text.trim();
  if (!trimmedText) return defaultResult;

  // Pattern 1: Ada connector
  const connectorPattern = /^(.+?)\s+(متعلق بمحذوف|متعلق بالفعل|متعلق بالخبر|متعلق بالمبتدأ|متعلق بـ|صفة لـ|صفة ل|بدل|عطف بيان|توكيد)\b(.*)$/;

  const connectorMatch = trimmedText.match(connectorPattern);

  if (connectorMatch) {
    return {
      main:      connectorMatch[1].trim(),
      connector: connectorMatch[2].trim(),
      detail:    (connectorMatch[3] || '').trim(),
    };
  }

  // Pattern 2: Ada state (مبني/مرفوع/منصوب/مجرور/مجزوم)
  const statePattern = /^(.+?)\s+(مبني على [^\s]+(?:\sلاتصاله[^\s]*)?|مرفوع|منصوب|مجرور|مجزوم|في محل [^\s]+)(.*)$/;

  const stateMatch = trimmedText.match(statePattern);

  if (stateMatch) {
    return {
      main:      stateMatch[1].trim(),
      connector: '',
      detail:    (stateMatch[2] + (stateMatch[3] || '')).trim(),
    };
  }

  return {
    main:      trimmedText,
    connector: '',
    detail:    '',
  };
}

// ════════════════════════════════════════════════════════════
// KAMUS ARTI KATA (Arab → Indonesia)
// Untuk tab "Arti" dan WordCard
// ════════════════════════════════════════════════════════════

export const wordMeaningDictionary = {
  // ── Fi'il Madhi (Kata Kerja Lampau) ──
  'وَصَلَتْ':      'telah sampai',
  'وَصَلَ':        'telah sampai',
  'اشْتَهَى':      'menginginkan / berhasrat',
  'انْتَشَرَتْ':   'menyebar',
  'انْتَشَرَ':     'menyebar',
  'صَارَ':         'menjadi / berubah',
  'كَسَاهُ':       'mengenakan / menutupi',
  'كَسَاهَا':      'mengenakan (perempuan)',
  'كَسَاهُمْ':     'mengenakan (mereka)',
  'زَادَ':         'bertambah',
  'يَزْدَادُ':     'bertambah',
  'كَتَبَ':        'telah menulis',
  'يَكْتُبُ':      'menulis',
  'قَرَأَ':        'telah membaca',
  'يَقْرَأُ':      'membaca',
  'ذَهَبَ':        'telah pergi',
  'يَذْهَبُ':      'pergi',
  'دَخَلَ':        'telah masuk',
  'يَدْخُلُ':      'masuk',
  'خَرَجَ':        'telah keluar',
  'يَخْرُجُ':      'keluar',
  'جَلَسَ':        'telah duduk',
  'يَجْلِسُ':      'duduk',
  'قَامَ':         'telah berdiri',
  'يَقُومُ':       'berdiri',
  'نَامَ':         'telah tidur',
  'يَنَامُ':       'tidur',
  'أَكَلَ':        'telah makan',
  'يَأْكُلُ':      'makan',
  'شَرِبَ':        'telah minum',
  'يَشْرَبُ':      'minum',
  'ضَرَبَ':        'telah memukul',
  'يَضْرِبُ':      'memukul',
  'قَالَ':         'telah berkata',
  'يَقُولُ':       'berkata',
  'سَأَلَ':        'telah bertanya',
  'يَسْأَلُ':      'bertanya',

  // ── Fi'il Mudhari' (Kata Kerja Sekarang/Akan Datang) ──
  'تَكْتُبُ':      'menulis (pr)',
  'تَكْتُبُينَ':   'menulis (pr, kamu)',
  'أَكْتُبُ':      'saya menulis',
  'يَذْهَبُونَ':   'mereka pergi',
  'يَذْهَبَانِ':   'mereka berdua pergi',

  // ── Isim (Kata Benda) - Roh / Jiwa ──
  'الرُّوحُ':      'ruh / jiwa',
  'الرُّوحَ':      'ruh / jiwa (obj)',
  'الرُّوحِ':      'ruh / jiwa',
  'الرُّوح':       'ruh / jiwa',
  'الرُّوحَيْنِ':  'dua ruh',

  // ── Isim - Anggota Tubuh ──
  'جَوْفِهِ':      'perutnya',
  'جَوْفِ':        'perut',
  'جَوْفٍ':        'perut',
  'جَسَدِهِ':      'tubuhnya',
  'جَسَدِ':        'tubuh',
  'جَسَدٍ':        'tubuh',
  'يَدِهِ':        'tangannya',
  'يَدِ':          'tangan',
  'رِجْلِهِ':      'kakinya',
  'رِجْلِ':        'kaki',
  'رَأْسِهِ':      'kepalanya',
  'رَأْسِ':        'kepala',
  'عَيْنِهِ':      'matanya',
  'عَيْنِ':        'mata',
  'أَنَامِلِهِ':   'jari-jarinya',
  'أَنَامِلِ':     'jari-jari',
  'قَلْبِهِ':      'hatinya',
  'قَلْبِ':        'hati',

  // ── Isim - Makanan & Minuman ──
  'الطَّعَامَ':    'makanan',
  'الطَّعَام':     'makanan',
  'الطَّعَامِ':    'makanan',
  'الْمَاءَ':      'air',
  'الْمَاء':       'air',
  'الْخُبْزَ':     'roti',
  'الْخُبْز':      'roti',
  'اللَّحْمَ':     'daging',
  'اللَّحْم':      'daging',
  'الْحَلِيبَ':    'susu',

  // ── Isim - Bagian Tubuh & Materi ──
  'لَحْمًا':       'daging',
  'لَحْمٍ':        'daging',
  'لَحْمَ':        'daging',
  'دَمًا':         'darah',
  'دَمٍ':          'darah',
  'دَمَ':          'darah',
  'وُرُوقًا':      'urat-urat',
  'عَصَبًا':       'saraf-saraf',
  'عَظْمًا':       'tulang',
  'جِلْدًا':       'kulit',

  // ── Isim - Konsep Abstrak ──
  'بَقِيَّةٌ':     'sisa / tersisa',
  'بَقِيَّةٍ':     'sisa / tersisa',
  'بَقِيَّةً':     'sisa / tersisa',
  'حَيَاةً':       'kehidupan',
  'مَوْتًا':       'kematian',
  'عِلْمًا':       'ilmu',
  'كِتَابًا':      'buku',

  // ── Isim - Orang & Makhluk ──
  'النَّارَ':      'api',
  'الْمَلَكَ':     'malaikat',
  'الْإِنْسَانَ':  'manusia',
  'الرَّجُلَ':     'laki-laki',
  'الْمَرْأَةَ':   'perempuan',
  'الطَّالِبَ':    'pelajar (lk)',
  'الطَّالِبَةَ':  'pelajar (pr)',
  'الْأُسْتَاذَ':  'guru (lk)',
  'الْأُسْتَاذَةَ': 'guru (pr)',
  'الْوَلَدَ':     'anak laki-laki',
  'الْبِنْتَ':     'anak perempuan',

  // ── Huruf (Particles) ──
  'فَ':            'huruf athaf (maka / lalu)',
  'وَ':            'huruf athaf (dan)',
  'ثُمَّ':         'huruf athaf (kemudian)',
  'أَوْ':          'huruf athaf (atau)',
  'لَمَّا':        'keterangan waktu (tatkala)',
  'حَيْثُمَا':     'keterangan tempat (di mana)',
  'إِذَا':         'keterangan waktu (apabila)',
  'إِذْ':          'keterangan waktu (ketika)',

  // ── Huruf Jar ──
  'إِلَى':         'huruf jar (kepada / ke)',
  'فِي':           'huruf jar (di dalam)',
  'مِنْ':          'huruf jar (dari)',
  'عَلَى':         'huruf jar (di atas)',
  'عَنْ':          'huruf jar (dari / tentang)',
  'لِ':            'huruf jar (untuk / milik)',
  'بِ':            'huruf jar (dengan / sebab)',
  'كَ':            'huruf jar (seperti)',
  'حَتَّى':        'huruf jar (hingga / sampai)',

  // ── Huruf Jar + Dhamir ──
  'مِنْهُ':        'darinya',
  'مِنْهَا':       'darinya (pr)',
  'مِنْهُمْ':      'dari mereka',
  'إِلَيْهِ':      'kepadanya',
  'إِلَيْهَا':     'kepadanya (pr)',
  'فِيهِ':         'di dalamnya',
  'فِيهَا':        'di dalamnya (pr)',
  'عَلَيْهِ':      'di atasnya',
  'عَلَيْهَا':     'di atasnya (pr)',
  'لَهُ':          'baginya (lk)',
  'لَهَا':         'baginya (pr)',
  'بِهِ':          'dengannya',
  'بِهَا':         'dengannya (pr)',

  // ── Adawat (Kata Keterangan) ──
  'كُلِّ':         'seluruh',
  'كُلَّ':         'seluruh',
  'كُلُّ':         'seluruh',
  'كُلٍّ':         'seluruh',
  'بَعْضِ':        'sebagian',
  'بَعْضُ':        'sebagian',
  'جَمِيعِ':       'semua',
  'جَمِيعُ':       'semua',
  'قَلِيلًا':      'sedikit',
  'كَثِيرًا':      'banyak',

  // ── Dhamir (Kata Ganti) ──
  'هُوَ':          'dia (lk)',
  'هِيَ':          'dia (pr)',
  'هُمَا':         'mereka berdua',
  'أَنْتَ':        'kamu (lk)',
  'أَنْتِ':        'kamu (pr)',
  'أَنْتُمَا':     'kamu berdua',
  'نَحْنُ':        'kami / kita',
  'هُمْ':          'mereka (lk)',
  'هُنَّ':         'mereka (pr)',
  'أَنْتُمْ':      'kamu semua (lk)',
  'أَنْتُنَّ':     'kamu semua (pr)',
};

// ── Fungsi: Ambil arti kata dari kamus ─────────────────────
export function getWordMeaning(word) {
  if (!word) return null;
  const clean = word.trim();
  return wordMeaningDictionary[clean] || null;
}

// ── Fungsi: Cek apakah kata punya arti di kamus ────────────
export function hasWordMeaning(word) {
  if (!word) return false;
  return word.trim() in wordMeaningDictionary;
}

// ════════════════════════════════════════════════════════════
// DEFAULT EXPORT
// ════════════════════════════════════════════════════════════

const nahwuDictionary = {
  transliterationMap,
  transliterateDetail,
  transliterateIrab,
  parseIrab,
  wordMeaningDictionary,
  getWordMeaning,
  hasWordMeaning,
};

export default nahwuDictionary;